module.exports = __webpack_public_path__ + "static/media/Catalogue_Digital_MBA_2021__1_.8fd3e3b3.pdf";